const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

var popups = document.querySelectorAll('.video-popup');
if (popups.length > 0) {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	window.onYouTubeIframeAPIReady = function() {
		popups.forEach(function(popup) {
			let player = null;
			const dialog = popup.querySelector("dialog");
			const openButton = popup.querySelector(".button-open");
			const closeButton = popup.querySelector(".button-close");
			const youtube = popup.querySelector("[data-youtube]");

			openButton.addEventListener("click", () => {
				dialog.showModal();
				// disableBodyScroll(dialog);
				if (!player)  {
					player = new YT.Player(youtube, {
						width: 640,
						height: 640 * (9 / 16),
						videoId: youtube.dataset.youtube,
						playerVars: {
							// 'controls': 0,
							'color': 'white',
							'playsinline': 1,
							'rel': 0, // disable related videos
							// 'autoplay': 1,
						},
						events: {
							// 'onReady': () => fn(player),
							'onStateChange': (e) => console.log('onStateChange', Object.keys(YT.PlayerState).find(key => YT.PlayerState[key] === e.data)),
						}
					});
				}
				setTimeout(function() {
					dialog.classList.add("open");
					// player.playVideo();
				}, 25);
			});
			// Click close button to close
			closeButton.addEventListener("click", () => {
				dialog.classList.add("closing");
				player.pauseVideo();
				setTimeout(function() {
					dialog.close();
				}, 300)
			});

			// Click backdrop to close
			dialog.addEventListener("click", (e) => {
				if (e.target === dialog) {
					dialog.classList.add("closing");
					player.pauseVideo();
					setTimeout(function() {
						dialog.close();
					}, 300)
				}
			});
			dialog.addEventListener("close", () => {
				dialog.classList.remove("open");
				dialog.classList.remove("closing");
				player.pauseVideo();
				// enableBodyScroll(dialog);
			});

		});
	}
}